<header>
  <ng-content select="[xHeading]"></ng-content>
  <ng-content select="[xHeaderAction]"></ng-content>
</header>
<section>
  <ng-content></ng-content>
</section>
<footer>
  <ng-content select="[xFooterAction]"></ng-content>
</footer>
